import React, { useEffect } from "react";
import { setFlowData } from "@/components/PageHome/redux/slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import {
  FlowProps,
  ICON_STYLE,
  MODAL_KEYS,
  MODAL_TYPES,
  renderModalContent,
} from "@/components/PageHome/components/OnboardingSection/Flows/helpers";
import flowSelector from "@/components/PageHome/redux/selectors/flowData";
import { NewMother as NewMotherAttr } from "@/components/PageHome/redux/types";
import { onBoardUser } from "@/components/PageHome/redux/actions";
import { dateToString } from "@/helpers";

const NewMom: React.FC<FlowProps> = ({ isModalOpen, setIsModalOpen, birthDate }) => {
  const flowData = useAppSelector(flowSelector) as NewMotherAttr;

  const [selectedModel, setSelectedModel] = React.useState<number>(1);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const closeFunction = FlowData[selectedModel][MODAL_KEYS.onClose];

    if (isModalOpen === false && closeFunction && typeof closeFunction === "function") {
      closeFunction();
    }
  }, [isModalOpen]);

  const dispatchOnBoarding = (): void => {
    dispatch(onBoardUser());

    if (setIsModalOpen) {
      setIsModalOpen(false);
    }
  };

  const FlowData = {
    1: {
      [MODAL_KEYS.type]: MODAL_TYPES.birthDate,
      [MODAL_KEYS.initialDate]: birthDate,
      [MODAL_KEYS.ctaText]: "Submit",
      [MODAL_KEYS.btnClick]: (date: Date): void => {
        if (date) {
          const dateString = dateToString(date);
          dispatch(setFlowData({ ...flowData, birthDate: dateString }));
        }

        dispatchOnBoarding();
      },
      [MODAL_KEYS.ctaBelowText]: <button onClick={dispatchOnBoarding}>I don’t remember my baby’s birthday</button>,
      [MODAL_KEYS.bgIcon]: { iconStyle: ICON_STYLE.style2, className: ["bgIconTopRight"] },
    },
  };

  return renderModalContent(FlowData[selectedModel]);
};

export default NewMom;
